var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CieloLayout',{attrs:{"layout-version":"v1"}},[_c('div',{staticClass:"container text-center mt-5"},[_c('h1',{staticClass:"error-title",attrs:{"tabindex":"0"}},[_vm._v("\n            404\n        ")]),_c('h2',{staticClass:"error-subtitle mt-3",attrs:{"tabindex":"0"}},[_vm._v("\n            Ooops, página não encontrada.\n        ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }